import { Tabs, Tab, Box } from "@mui/material"
import { useState } from "react";
import LabComponent from "./Lab/LabComponent";
// import FamilyHistory from "../History/FamilyHistory/FamilyHistory"
// import Radiologyform from "./Radiology/components/Radiologyform";
import Radiology from "./Radiology/Radiology";


interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
  }
function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
      </div>
    );
  }

function a11yProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }


function Investigation() {

    const handleChange = (_: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
      };
      const [value,setValue]=useState(0)
  return (
    <div>
            <Tabs
              value={value}
              onChange={handleChange}
              // variant="fullWidth"
              scrollButtons
              allowScrollButtonsMobile
              aria-label="scrollable force tabs example" >
                   <Tab label="Lab" {...a11yProps(0)} />
                   <Tab label="Radiology" {...a11yProps(1)} />
               
            </Tabs>

         <CustomTabPanel value={value} index={0}>
                <LabComponent/>
          </CustomTabPanel>
         <CustomTabPanel value={value} index={1}>
                <Radiology/>
         </CustomTabPanel>
    </div>
  )
}

export default Investigation
